import React from 'react'
import _ from 'lodash'
import {buildField} from '@eitje/form'
import {Checkbox} from '~/components'

const CheckboxFieldInner = buildField(({value, ...fieldProps}) => <Checkbox {...fieldProps} checked={!!value} />, {
	className: 'checkbox-field',
	withIcon: false,
	clearIcon: false,
})

export const CheckboxField = React.memo(CheckboxFieldInner, _.isEqual)
